import { Component, createRef } from "react"

/* Components */
import Icon from "../../components/Icon"


/* The mounted widget — the helper below talks to it */
let widget = null

/* The hours of a day and the minutes with a step of five */
const HOURS = Array.from({ length: 24 }, (item, index) => `${index}`.padStart(2, "0"))
const MINUTES = Array.from({ length: 12 }, (item, index) => `${index * 5}`.padStart(2, "0"))

/* The hours a working day usually starts and ends with */
const PRESETS = ["08:00", "09:00", "10:00", "11:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"]


/* Read a time as it is kept — "09:00", "9:0" and an empty value all come back whole */
const parse = value => {

    const parts = `${value === null || value === undefined ? "" : value}`.split(":")

    const hour = parseInt(parts[0])
    const minute = parseInt(parts[1])

    return {
        hour: isNaN(hour) ? "09" : `${Math.min(Math.max(hour, 0), 23)}`.padStart(2, "0"),
        /* The minutes are kept with a step of five — anything between rounds down to it */
        minute: isNaN(minute) ? "00" : `${Math.min(Math.floor(minute / 5) * 5, 55)}`.padStart(2, "0")
    }
}


/* Widget Time Modal — the hour is chosen here and not in the window the browser draws by itself.
   It stands above the forms of the panel, so it works from inside the card of a master */
class TimeModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            leaving: false,
            title: "",
            hour: "09",
            minute: "00"
        }

        /* The chosen hour is given back to the one who asked for it */
        this.resolve = null

        /* The columns scroll to what is chosen when the window opens */
        this._hours = createRef()
        this._minutes = createRef()
    }

    componentDidMount = () => {

        /* The helper asks for the hour here */
        widget = this

        document.addEventListener("keydown", this.keydown)
    }

    componentWillUnmount = () => {

        document.removeEventListener("keydown", this.keydown)

        clearTimeout(this.timer)
        widget = null
    }

    /* The escape key closes the window without an answer */
    keydown = event => {

        if (event.key === "Escape" && this.state.visible) {
            this.answer(null)
        }
    }

    /* Ask for the hour */
    ask = options => {

        return new Promise(resolve => {

            const { hour, minute } = parse(options ? options.value : "")

            this.resolve = resolve
            this.setState({ visible: true, leaving: false, title: options && options.title ? options.title : "Время", hour, minute }, () => this.scroll())
        })
    }

    /* Bring what is chosen into the middle of its column */
    scroll = () => {

        for (const column of [this._hours, this._minutes]) {

            /* Check Column */
            if (!column.current) {
                continue
            }

            const active = column.current.querySelector(".time-modal-item.active")

            if (active) {
                column.current.scrollTop = active.offsetTop - (column.current.clientHeight / 2) + (active.clientHeight / 2)
            }
        }
    }

    /* Answer it */
    answer = value => {

        /* Fields */
        const { visible, leaving } = this.state

        /* Already answered */
        if (!visible || leaving) {
            return
        }

        this.setState({ leaving: true })

        if (this.resolve) {
            this.resolve(value)
            this.resolve = null
        }

        this.timer = setTimeout(() => this.setState({ visible: false, leaving: false }), 180)
    }

    /* One column of the window */
    _column = (text, values, chosen, key, reference) => {

        return (
            <div className="time-modal-column">

                <div className="time-modal-column-text">{text}</div>

                <div ref={reference} className="time-modal-list">
                    {values.map(value =>
                        <div
                            key={value}
                            onClick={() => this.setState({ [key]: value })}
                            className={`time-modal-item ${chosen === value ? "active" : ""}`}
                        >
                            {value}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, leaving, title, hour, minute } = this.state

        /* Check Data */
        if (!visible) {
            return null
        }

        const value = `${hour}:${minute}`

        return (
            <div onClick={() => this.answer(null)} className={`time-modal-overlay ${leaving ? "leaving" : ""}`}>

                <div onClick={event => event.stopPropagation()} className={`time-modal ${leaving ? "leaving" : ""}`}>

                    <div className="time-modal-header">
                        <h2>{title}</h2>
                        <div onClick={() => this.answer(null)} className="time-modal-close">
                            <Icon name="close" size={11} width={2.2} />
                        </div>
                    </div>

                    <div className="time-modal-value">{value}</div>

                    <div className="time-modal-columns">
                        {this._column("Часы", HOURS, hour, "hour", this._hours)}
                        {this._column("Минуты", MINUTES, minute, "minute", this._minutes)}
                    </div>

                    <div className="time-modal-presets">
                        {PRESETS.map(preset =>
                            <div
                                key={preset}
                                onClick={() => this.setState(parse(preset), () => this.scroll())}
                                className={`time-modal-preset ${value === preset ? "active" : ""}`}
                            >
                                {preset}
                            </div>
                        )}
                    </div>

                    <div className="time-modal-buttons">
                        <div onClick={() => this.answer(null)} className="time-modal-button light">Отмена</div>
                        <div onClick={() => this.answer(value)} className="time-modal-button">Готово</div>
                    </div>

                </div>

            </div>
        )
    }
}


/* Ask for the hour — the answer comes as a promise, an empty one means nothing was chosen */
export const pickTime = options => {

    /* The widget is not mounted — nothing was asked */
    if (!widget) {
        return Promise.resolve(null)
    }

    return widget.ask(options)
}


export default TimeModal
